import requestAnimationFrame
from 'vt-frontend-engine/app/scripts/principles/performance/requestAnimationFrame';
import _matchViewport from 'vt-frontend-engine/app/scripts/principles/responsive/match-viewport';
import { setupCollapse, updateElements } from './collapse';

(function() {
  const breakpoint = 'width-xl';
  var widerThanBreakpoint = false;

  function checkWidth() {
    if (widerThanBreakpoint != _matchViewport(breakpoint)) {
      widerThanBreakpoint = !widerThanBreakpoint;
      updateElements('.js-seo-content-collapsible-content',
                     '.js-seo-content-collapsible-show-more',
                     '.js-seo-content-collapsible-show-less',
                     widerThanBreakpoint);

      updateElements('.js-seo-footer-content-collapsible-content',
                     '.js-seo-footer-content-collapsible-show-more',
                     '.js-seo-footer-content-collapsible-show-less',
                     widerThanBreakpoint);
    }
  }

  function _bindEvents() {
    $(window).on('resize', function () {
      requestAnimationFrame(checkWidth);
    });

    setupCollapse('.js-seo-content-collapsible-content',
                  '.js-seo-content-collapsible-show-more',
                  '.js-seo-content-collapsible-show-less');

    setupCollapse('.js-our-approach-collapsible-content',
                  '.js-our-approach-collapsible-show-more',
                  '.js-our-approach-collapsible-show-less');

    setupCollapse('.js-seo-footer-content-collapsible-content',
                  '.js-seo-footer-content-collapsible-show-more',
                  '.js-seo-footer-content-collapsible-show-less');
  }

  $(document).ready(function() {
    _bindEvents();
    checkWidth();
  });
})();
